import { Directive } from '@angular/core';
import moment from 'moment';
import { HealthInsuranceMetadata } from 'src/app/_types/lead.types';
import {
  getDentalIntervalLabel,
  getHealthBaseInsuranceLabel,
  getHealthPrestationsLabel,
  getHospitalInsuranceLabel,
  getPaymentMethodLabel,
} from 'src/app/enums/health.enums';
import { getPaymentFrequencyLabel } from 'src/app/enums/payment-frequency.enum';
import { getSexEnumLabel } from 'src/app/enums/sex.enum';
import { compareArrays, getBooleanLabel } from 'src/app/helpers/utils';

import { BaseMetadataComponent } from '../base-metadata.component';

@Directive()
export abstract class HealthMetadataComponentAbstract extends BaseMetadataComponent<HealthInsuranceMetadata> {
  getDentalIntervalLabel = getDentalIntervalLabel;

  getHospitalInsuranceLabel = getHospitalInsuranceLabel;

  getPaymentMethodLabel = getPaymentMethodLabel;

  getPaymentFrequencyLabel = getPaymentFrequencyLabel;

  getHealthBaseInsuranceLabel = getHealthBaseInsuranceLabel;

  getHealthPrestationsLabel = getHealthPrestationsLabel;

  getSexEnumLabel = getSexEnumLabel;

  getAge(date: string): number {
    const today = new Date();
    const birthDate = moment(date, 'DD/MM/YYYY').toDate();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  getBooleanLabel = getBooleanLabel;

  compareArrays = compareArrays;

  displayComplementaryQuestionnary(metadata: HealthInsuranceMetadata) {
    return (
      metadata?.paymentFrequency ||
      metadata?.paymentMethod ||
      metadata?.iban ||
      metadata?.startDatePrestations ||
      metadata?.startDateBase ||
      metadata?.avsNumber ||
      metadata?.maritalStatus ||
      (metadata?.alreadyCssClient !== null &&
        metadata?.alreadyCssClient !== undefined) ||
      (metadata?.alreadyGMClient !== null &&
        metadata?.alreadyGMClient !== undefined) ||
      (metadata?.alreadyHelsanaClient !== null &&
        metadata?.alreadyHelsanaClient !== undefined) ||
      (metadata?.alreadySwicaClient !== null &&
        metadata?.alreadySwicaClient !== undefined) ||
      (metadata?.refusedOrRestricted !== null &&
        metadata?.refusedOrRestricted !== undefined) ||
      metadata?.bankNameAddress ||
      metadata?.helsanaNumber
    );
  }
}
